import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import filterMenu from '@core/reducers/menu/actions/filterMenu';

import DesktopShelvesMenuHeader from './DesktopShelvesMenuHeader';

const mapDispatchToProps = {
  filterMenu,
};

const withConnect = connect(null, mapDispatchToProps);

export default compose(withRouter, withConnect)(DesktopShelvesMenuHeader);
